import { Amplify } from "aws-amplify";
import config from "../config";

Amplify.configure({
  Auth: {
    Cognito: {
      // biome-ignore lint/style/noNonNullAssertion: <explanation>
      userPoolClientId: config.cognito.userPoolClientId!,
      // biome-ignore lint/style/noNonNullAssertion: <explanation>
      userPoolId: config.cognito.userPoolId!,
      loginWith: {
        email: true,
      },
    },
  },
});

export default function InitializeAmplify() {
  return null;
}
